import * as React from 'react';
import { IItemClickParams } from '@cian/geosuggest-widget';
import { useSelector } from 'react-redux';

import { useActions } from '../../useActions';

import { selectEstimationTarget, selectFormFields } from '../../../selectors';

import { ECurrentErrorField } from '../../../types/formFields';
import { EMyHomeEstimationTargets } from '../../../types/estimationTarget';

import { prepareTrackMyHomeAddressPick } from '../../tracking';

/**
 * Обработчик клика по итему в геосаджесте (список предложенных адресов)
 * Принимает
 *   * errorMessage - ошибка в фильтрах в поле address
 *   * timerId - ID таймера, по которому будет отправляться аналитика, задан
 * */
export const useHandleSuggestItemClick = (errorMessage: string, timerId?: number) => {
  const { address } = useSelector(selectFormFields);
  const estimationTarget = useSelector(selectEstimationTarget);

  const { setError, setAddress, setFlatNumber, setRooms, setArea, getGeocode } = useActions();

  // oxlint-disable-next-line react/exhaustive-deps
  const trackAddressPick = React.useCallback(prepareTrackMyHomeAddressPick(), []);

  return (params: IItemClickParams) => {
    /** Очищается таймаут, который задается в useAddressProps для аналитики */
    clearTimeout(timerId);

    /** если есть ошибка, она сбросится */
    if (errorMessage) {
      setError({ currentErrorField: ECurrentErrorField.none, errorText: '' });
    }

    trackAddressPick(address, params.title, estimationTarget);
    setAddress(params.title);

    /* istanbul ignore else */
    if (estimationTarget === EMyHomeEstimationTargets.flat) {
      /** Отчищаем предзаполненные поля */
      setFlatNumber(undefined);
      setRooms(undefined);
      setArea(undefined);

      getGeocode(params.title);
    }
  };
};
